import React from 'react';

import CardSetContainer from './react/card/CardSetContainer';
import './app.less';

const App = () => <div className="novselect-app extra-classy main-app"><CardSetContainer /></div>

export default App;



// WEBPACK FOOTER //
// ./src/App.js